export enum TOAST_TEST_IDS {
    TOAST_CONTAINER = 'toast_message',
}
